import { ref, computed } from 'vue';

const loadingCounter = ref(0);

export function useLoadingState() {
    const isLoading = computed(() => loadingCounter.value > 0);

    const incrementLoading = () => {
        loadingCounter.value++;
    };

    const decrementLoading = () => {
        if (loadingCounter.value > 0) {
            loadingCounter.value--;
        }
    };

    return {
        isLoading,
        incrementLoading,
        decrementLoading,
    };
}